// @flow
import React from "react"
import { compose, type HOC } from "recompose"
import { openModal } from "data/modals/actions"
import withConnect from "hoc/withConnect"
import ModalBody from "modals/_Body"
import ModalHeader from "modals/_Header"
import SignUpForm from "./SignUpForm"

const SignUpModal = ({ close, openLogin, onSuccess, callback }) => (
  <ModalBody close={close}>
    <ModalHeader close={close} title="Get Your Rental" />
    <SignUpForm close={close} onSuccess={onSuccess} callback={callback} />
  </ModalBody>
)

type Outter = {|
  close: Function,
  onSuccess?: Function,
  callback?: Function,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(() => ({}), { openModal }),
)

export default enhancer(SignUpModal)



// WEBPACK FOOTER //
// ./src/modals/SignUp/index.js